<div class="dialogWrapper">
  <div class="dialogHeader">
    <div>
      <h2>{{ product?.brand?.description }} {{ product?.article }}</h2>
      <div class="subtitle">{{ product?.description }}</div>
      <div class="subtitle" *ngIf="warehouse">Склад: {{ warehouse.description }}</div>
    </div>
    <button mat-icon-button type="button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div *ngIf="warehouseSummary" class="summaryGrid">
    <div class="summaryCard">
      <div class="summaryLabel">Размещено</div>
      <div class="summaryValue">{{ warehouseSummary.placedQty }}</div>
    </div>
    <div class="summaryCard" [class.debt]="bufferQty < 0">
      <div class="summaryLabel">{{ bufferSummaryLabel }}</div>
      <div class="summaryValue">{{ bufferQty }}</div>
    </div>
    <div class="summaryCard" [class.debt]="addressDebtQty < 0">
      <div class="summaryLabel">{{ unassignedOutSummaryLabel }}</div>
      <div class="summaryValue">{{ addressDebtQty }}</div>
    </div>
    <div class="summaryCard">
      <div class="summaryLabel">Итого склад</div>
      <div class="summaryValue">{{ warehouseSummary.aggregateQty }}</div>
    </div>
  </div>

  <div *ngIf="recommendedCells.length" class="recommended">
    <span class="recommendedLabel">Рекомендуемые полки:</span>
    <span class="chip" *ngFor="let cell of recommendedCells">{{ cell }}</span>
  </div>

  <div *ngIf="hasResolvableVirtualOffset" class="warningBanner virtualOffsetWarning">
    <div>
      <strong>Встречные виртуальные остатки.</strong>
      Товар одновременно числится размещенным без источника и снятым без списания. Полки и общий
      остаток при исправлении не изменятся.
    </div>
    <button
      mat-stroked-button
      type="button"
      *ngIf="canUseCountMode && !virtualOffsetPreview"
      [disabled]="virtualOffsetLoading"
      (click)="previewVirtualOffset()"
    >
      Проверить исправление
    </button>
    <div class="adminHint" *ngIf="!canUseCountMode">Исправление доступно администратору.</div>
  </div>

  <div *ngIf="bufferQty < 0 && !hasResolvableVirtualOffset" class="warningBanner">
    Есть долг размещения: на полках зафиксировано больше товара, чем поступило в буфер.
  </div>

  <div *ngIf="addressDebtQty < 0" class="warningBanner">
    Товар списан без подтвержденного снятия с конкретной полки.
  </div>

  <div *ngIf="virtualOffsetPreview as preview" class="virtualOffsetPreview">
    <div class="offsetPreviewHeader">
      <div>
        <div class="sectionTitle">Предпросмотр исправления</div>
        <div class="offsetDescription">
          Будет погашено {{ preview.resolveQty }}. Полки и итог склада останутся без изменений.
        </div>
      </div>
      <button
        mat-button
        type="button"
        [disabled]="virtualOffsetLoading"
        (click)="cancelVirtualOffset()"
      >
        Отмена
      </button>
    </div>
    <div class="offsetChanges">
      <div>
        <span>Долг размещения</span>
        <strong>{{ preview.before.bufferQty }} → {{ preview.after.bufferQty }}</strong>
      </div>
      <div>
        <span>Снято, ожидает списания</span>
        <strong
          >{{ preview.before.unassignedOutQty }} → {{ preview.after.unassignedOutQty }}</strong
        >
      </div>
      <div>
        <span>На полках</span>
        <strong>{{ preview.before.placedQty }} → {{ preview.after.placedQty }}</strong>
      </div>
      <div>
        <span>Итого склад</span>
        <strong>{{ preview.before.aggregateQty }} → {{ preview.after.aggregateQty }}</strong>
      </div>
    </div>
    <div class="warningBanner" *ngIf="!preview.canResolve && preview.reason">
      {{ preview.reason }}
    </div>
    <div class="offsetActions">
      <button
        mat-flat-button
        color="primary"
        type="button"
        [disabled]="virtualOffsetLoading || !preview.canResolve"
        (click)="confirmVirtualOffset()"
      >
        Подтвердить взаимозачет {{ preview.resolveQty }}
      </button>
    </div>
  </div>

  <mat-tab-group class="stockTabs" animationDuration="0ms">
    <mat-tab label="Остатки">
      <div class="stockTabPane">
        <div class="managerBlock">
          <div class="sectionTitle">Управление без сканера</div>
          <div class="modeRow">
            <button
              mat-stroked-button
              type="button"
              [ngClass]="{ activeMode: actionMode === 'PICK' }"
              (click)="selectMode('PICK')"
            >
              Снять с полки
            </button>
            <button
              mat-stroked-button
              type="button"
              [ngClass]="{ activeMode: actionMode === 'PLACE' }"
              (click)="selectMode('PLACE')"
            >
              Разместить
            </button>
            <button
              mat-stroked-button
              type="button"
              *ngIf="canUseCountMode"
              [ngClass]="{ activeMode: actionMode === 'COUNT' }"
              (click)="selectMode('COUNT')"
            >
              Переучет
            </button>
          </div>

          <div class="actionGrid">
            <div class="fieldSlot">
              <mat-form-field *ngIf="actionMode === 'PICK'" appearance="outline">
                <mat-label>С какой полки снять</mat-label>
                <mat-select [(value)]="sourceCellId">
                  <mat-option *ngFor="let row of realBalances" [value]="row.cellId">
                    {{ getCellLabel(row) }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field *ngIf="actionMode === 'PLACE'" appearance="outline">
                <mat-label>Источник</mat-label>
                <mat-select [(value)]="sourceCellId">
                  <mat-option [value]="null">Автоматически: снятие / буфер</mat-option>
                  <mat-option *ngFor="let row of sourceOptions" [value]="row.cellId">
                    {{ getCellLabel(row) }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="fieldSlot">
              <mat-form-field
                *ngIf="actionMode === 'PLACE' || actionMode === 'COUNT'"
                appearance="outline"
              >
                <mat-label>{{
                  actionMode === 'COUNT' ? 'Фактическая полка' : 'Куда положить'
                }}</mat-label>
                <input
                  matInput
                  [formControl]="targetCellControl"
                  [matAutocomplete]="targetCellAuto"
                  placeholder="Начните вводить код полки"
                />
                <button
                  mat-icon-button
                  matSuffix
                  type="button"
                  class="createCellButton"
                  *ngIf="canCreateTargetCell || creatingTargetCell"
                  [disabled]="creatingTargetCell"
                  (click)="createTargetCell()"
                  matTooltip="Создать новую полку"
                >
                  <mat-icon *ngIf="!creatingTargetCell">add</mat-icon>
                  <mat-spinner *ngIf="creatingTargetCell" [diameter]="18"></mat-spinner>
                </button>
                <mat-hint>Можно искать по коду. Если полки нет, нажмите +.</mat-hint>
                <mat-autocomplete
                  #targetCellAuto="matAutocomplete"
                  autoActiveFirstOption
                  (optionSelected)="onTargetCellSelected($event)"
                >
                  <mat-option *ngFor="let row of filteredTargetOptions" [value]="row.code">
                    {{ getWarehouseCellLabel(row) }}
                  </mat-option>
                  <mat-option
                    *ngIf="!filteredTargetOptions.length && targetCellQuery && !canCreateTargetCell"
                    disabled
                  >
                    Ничего не найдено
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>

            <div class="fieldSlot">
              <mat-form-field appearance="outline">
                <mat-label>Количество</mat-label>
                <input matInput type="number" step="0.01" [(ngModel)]="actionQty" />
              </mat-form-field>
            </div>

            <div class="actionButtonSlot">
              <button
                mat-flat-button
                color="primary"
                type="button"
                class="submitButton"
                [disabled]="!canSubmitAction"
                (click)="submitAction()"
              >
                {{
                  actionMode === 'PICK'
                    ? 'Подтвердить снятие'
                    : actionMode === 'PLACE'
                    ? 'Разместить товар'
                    : 'Сохранить факт'
                }}
              </button>
            </div>
          </div>
        </div>

        <div class="balancesBlock">
          <div class="balancesHeader">Остатки по ячейкам</div>
          <div *ngIf="!balances.length" class="emptyState">
            Нет адресных остатков для выбранного склада.
          </div>
          <div *ngIf="balances.length" class="balanceList">
            <div class="balanceRow" *ngFor="let row of balances" [class.debt]="row.qty < 0">
              <div class="balanceCode">{{ getBalanceCodeLabel(row) }}</div>
              <div class="balanceMeta">{{ getBalanceTypeLabel(row) }}</div>
              <div class="balanceQty">{{ row.qty }}</div>
              <div class="balanceActions" *ngIf="row.type === 'REAL'">
                <button mat-button type="button" (click)="prefillPick(row)" *ngIf="row.qty > 0">
                  Снять
                </button>
                <button mat-button type="button" (click)="prefillPlace(row)">Разместить</button>
                <button
                  mat-button
                  type="button"
                  (click)="prefillCount(row)"
                  *ngIf="canUseCountMode"
                >
                  Переучет
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        Журнал
        <span class="tabCount" *ngIf="movementTotal">{{ movementTotal }}</span>
      </ng-template>

      <div class="stockTabPane">
        <div class="movementsBlock">
          <div class="movementsHeader">
            <div>
              <div class="balancesHeader">Журнал</div>
              <div class="movementsSubheader" *ngIf="movementTotal">
                Показано {{ movementRows.length }} из {{ movementTotal }}
              </div>
            </div>
            <button
              mat-button
              type="button"
              [disabled]="movementLoading"
              (click)="reloadMovementRows()"
            >
              Обновить
            </button>
          </div>

          <div *ngIf="movementLoading && !movementRows.length" class="emptyState">
            Загружаем журнал...
          </div>
          <div *ngIf="!movementLoading && !movementRows.length" class="emptyState">
            Движений по этому товару и складу пока нет.
          </div>

          <div *ngIf="movementRows.length" class="movementTableWrapper">
            <table class="movementTable">
              <thead>
                <tr>
                  <th>Дата/время</th>
                  <th>Кто</th>
                  <th>Действие</th>
                  <th>Откуда</th>
                  <th>Куда</th>
                  <th>Кол-во</th>
                  <th>Источник</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of movementRows">
                  <td class="movementDate">{{ row.createdAt | date: 'dd.MM.yyyy HH:mm' }}</td>
                  <td>{{ getMovementUserLabel(row) }}</td>
                  <td class="movementAction">{{ getMovementActionLabel(row) }}</td>
                  <td>{{ getMovementCellLabel(row.fromCell) }}</td>
                  <td>{{ getMovementCellLabel(row.toCell) }}</td>
                  <td class="movementQty">{{ row.qty }}</td>
                  <td class="movementSource">{{ getMovementSourceLabel(row) }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="movementFooter" *ngIf="canLoadMoreMovements">
            <button
              mat-stroked-button
              type="button"
              [disabled]="movementLoading"
              (click)="loadMoreMovements()"
            >
              {{ movementLoading ? 'Загружаем...' : 'Показать еще' }}
            </button>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
